<img style="margin: 1rem" width="200" src="{{ imageQuestion }}" />
